import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-x-2 min-w-0">
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="text-taupe-grey hover:text-champagne-gold transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className={
                    isLast
                      ? 'text-silver-grey truncate max-w-[220px] md:max-w-[420px]'
                      : 'text-taupe-grey whitespace-nowrap'
                  }
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
              {!isLast && (
                <i
                  className="ri-arrow-right-s-line text-taupe-grey/70 text-base flex items-center justify-center w-3 h-3"
                  aria-hidden="true"
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}